import {
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { RouteWithSidebar } from "../components/RouteWithBars";
import Login from "../containers/login/index";
import Home from "../containers/home/index";
import { UserList } from "../containers/user/list";
import { UserRegister } from "../containers/user/register";
import NotFound from "../containers/notFound";
import storageService from "../services/storage.service";
import LoginLayoutRoute from "../containers/loginLayoutRoute";
import ForgotPassword from "../containers/forgotPassword";
import RecoverPassword from "../containers/recoverPassword";

import TransporterList from "../containers/transporter/list";
import { TransporterRegister } from "../containers/transporter/register";

import { ModelRegister } from "../containers/models/register";

import ConfigList from "../containers/config/parameters/list";
import { ConfigRegister } from "../containers/config/parameters/register";

import BranchList from "../containers/branch/list";
import { BranchRegister } from "../containers/branch/register";

import EquipmentList from "../containers/equipment/list";
import { EquipmentRegister } from "../containers/equipment/register";

import EventList from "../containers/event/event/list";
import { EventRegister } from "../containers/event/event/register";

import HolidayList from "../containers/event/holiday/list";
import { HolidayRegister } from "../containers/event/holiday/register";

import HolidaybranchList from "../containers/event/holidaybranch/list";
import { HolidaybranchRegister } from "../containers/event/holidaybranch/register";


import DashboardBranch from "../containers/dashboardBranch/index";

import ForecastList from "../containers/forecast/list";
import DepositList from "../containers/forecast/deposit/list";
import InconsistentList from "../containers/forecast/inconsistent/list";
import IndicatorList from "../containers/forecast/indicator/list";
import CollectionScheduleList from "../containers/forecast/collectionSchedule/list";
import PickuedUpEquipment from '../containers/forecast/pickuedUpEquipment/list';

import CockPitList from "../containers/forecast/cockpit/list";
import BalanceList from "../containers/forecast/balance/list";

import ReportList from "../containers/report/list";
import AnaliticalList from "../containers/report/analytical/list";
import CollectList from "../containers/report/collect/list";
import GroupList from "../containers/group/list";
import GroupRegister from "../containers/group/register";
import LoginBAS from "../containers/loginBAS/index";

import PickupImpositionConfig from "../containers/config/pickupImposition/register"

import IndicatorsList from "../containers/indicators/list";

import Imposedcollection from "../containers/indicators/imposedcollection/list";

import balancelimitexceeded from "../containers/indicators/balancelimitexceeded/list";
import CITConfig from "../containers/config/cit/list";
import SigaSatelliteList from "../containers/config/sigaSatellite/list";

import ApproverPickupMinList from "../containers/approverPickupMin/list";

import MultiEquipmentGroupList from "../containers/equipment/multiequipmentgroup/list";
import MultiEquipmentGroupRegister from "../containers/equipment/multiequipmentgroup/register";

import MinimumValuePickupJustifyJustificationList from     "../containers/config/minimumvaluepickupjustifyjustification/list";
import { MinimumValuePickupJustifyJustificationRegister } from "../containers/config/minimumvaluepickupjustifyjustification/register";

//import ConfigList from "../containers/config/list";


const Routes = () => {
  return (
    <Switch>
      <LoginLayoutRoute exact path="/LoginBAS" component={LoginBAS} />
      <LoginLayoutRoute exact path="/Login" component={Login} />
      <LoginLayoutRoute exact path="/ForgotPassword" component={ForgotPassword} />
      <LoginLayoutRoute exact path="/RecoverPassword/:token" component={RecoverPassword} />
      <Route exact path="/404" component={NotFound} />
      <PrivateRouteWithSidebar exact path="/" component={Home} />
      
      <PrivateRouteWithSidebar path="/Home" component={Home} />
      <PrivateRouteWithSidebar path="/DashboardBranch" component={DashboardBranch} />

      <PrivateRouteWithSidebar exact path="/User" component={UserList} />
      <PrivateRouteWithSidebar exact path="/User/add" component={UserRegister} />
      <PrivateRouteWithSidebar exact path="/User/edit/:id" component={UserRegister} />

      <PrivateRouteWithSidebar exact path="/Parameter/imposition" component={PickupImpositionConfig} /> 
      <PrivateRouteWithSidebar exact path="/Parameter/cit" component={CITConfig} /> 
      <PrivateRouteWithSidebar exact path="/Parameter/sigasatellite" component={SigaSatelliteList} />
      <PrivateRouteWithSidebar exact path="/Parameter" component={ConfigList} />
      <PrivateRouteWithSidebar exact path="/Parameter/edit/:id" component={ConfigRegister} />

      <PrivateRouteWithSidebar exact path="/Models" component={ModelRegister} />

      <PrivateRouteWithSidebar exact path="/Branch" component={BranchList} />
      <PrivateRouteWithSidebar exact path="/Branch/add" component={BranchRegister} />
      <PrivateRouteWithSidebar exact path="/Branch/edit/:id" component={BranchRegister} />

      <PrivateRouteWithSidebar exact path="/Group" component={GroupList} />
      <PrivateRouteWithSidebar exact path="/Group/add" component={GroupRegister} />
      <PrivateRouteWithSidebar exact path="/Group/edit/:id" component={GroupRegister} />

      <PrivateRouteWithSidebar exact path="/Transporter" component={TransporterList} />
      <PrivateRouteWithSidebar exact path="/Transporter/add" component={TransporterRegister} />
      <PrivateRouteWithSidebar exact path="/Transporter/edit/:id" component={TransporterRegister} />

      <PrivateRouteWithSidebar exact path="/Equipment" component={EquipmentList} />
      <PrivateRouteWithSidebar exact path="/Equipment/add" component={EquipmentRegister} />
      <PrivateRouteWithSidebar exact path="/Equipment/edit/:id" component={EquipmentRegister} />

      <PrivateRouteWithSidebar exact path="/Event" component={EventList} />
      <PrivateRouteWithSidebar exact path="/Event/add" component={EventRegister} />
      <PrivateRouteWithSidebar exact path="/Event/edit/:id" component={EventRegister} />

      <PrivateRouteWithSidebar exact path="/Holiday" component={HolidayList} />
      <PrivateRouteWithSidebar exact path="/Holiday/add" component={HolidayRegister} />
      <PrivateRouteWithSidebar exact path="/Holiday/edit/:id" component={HolidayRegister} />

      <PrivateRouteWithSidebar exact path="/Holidaybranch" component={HolidaybranchList} />
      <PrivateRouteWithSidebar exact path="/Holidaybranch/add" component={HolidaybranchRegister} />
      <PrivateRouteWithSidebar exact path="/Holidaybranch/edit/:id" component={HolidaybranchRegister} />


      <PrivateRouteWithSidebar exact path="/forecast/cockpit" component={CockPitList} /> 
      <PrivateRouteWithSidebar exact path="/forecast/balance" component={BalanceList} /> 
      <PrivateRouteWithSidebar exact path="/forecast/deposit" component={DepositList} /> 

      <PrivateRouteWithSidebar exact path="/forecast/indicator" component={IndicatorList} /> 
      <PrivateRouteWithSidebar exact path="/forecast/inconsistent" component={InconsistentList} /> 
      <PrivateRouteWithSidebar exact path="/forecast/" component={ForecastList} /> 
      <PrivateRouteWithSidebar exact path="/forecast/collectionSchedule" component={CollectionScheduleList} /> 
      <PrivateRouteWithSidebar exact path="/forecast/pickuedUpEquipment" component={PickuedUpEquipment} /> 
      

      <PrivateRouteWithSidebar exact path="/report/" component={ReportList} /> 
      <PrivateRouteWithSidebar exact path="/report/analytical" component={AnaliticalList} /> 
      <PrivateRouteWithSidebar exact path="/report/collect" component={CollectList} /> 

      <PrivateRouteWithSidebar exact path="/indicators/" component={IndicatorsList} /> 
      <PrivateRouteWithSidebar exact path="/indicators/imposedcollection" component={Imposedcollection} /> 

      <PrivateRouteWithSidebar exact path="/indicators/balancelimitexceeded" component={balancelimitexceeded} /> 

      <PrivateRouteWithSidebar exact path="/ApproverPickup" component={ApproverPickupMinList} />

      <PrivateRouteWithSidebar exact path="/equipment/multiequipmentgroup" component={MultiEquipmentGroupList} /> 
      <PrivateRouteWithSidebar exact path="/equipment/multiequipmentgroup/add" component={MultiEquipmentGroupRegister} />
      <PrivateRouteWithSidebar exact path="/equipment/multiequipmentgroup/edit/:id" component={MultiEquipmentGroupRegister} />

      <PrivateRouteWithSidebar exact path="/Parameter/minimumvaluepickupjustifyjustification" component={MinimumValuePickupJustifyJustificationList} /> 
      <PrivateRouteWithSidebar exact path="/Parameter/minimumvaluepickupjustifyjustification/add" component={MinimumValuePickupJustifyJustificationRegister} />
      <PrivateRouteWithSidebar exact path="/Parameter/minimumvaluepickupjustifyjustification/edit/:id" component={MinimumValuePickupJustifyJustificationRegister} />

      <Redirect to="/404" />
    </Switch>
  );
};

function PrivateRouteWithSidebar({ ...rest }) {
  let auth = storageService.getAccessToken();
  return (
    auth ? (
      <RouteWithSidebar exact component={rest.component} {...rest} />
    ) : (<Redirect
      to={{
        pathname: "/Login",
        state: { from: location }
      }}
    />
    )
  );
}

export default Routes;
